import { render, staticRenderFns } from "./ArrowLeft.vue?vue&type=template&id=a3d4fd2c"
import script from "./ArrowLeft.vue?vue&type=script&lang=ts"
export * from "./ArrowLeft.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports